import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Privilegio } from '../../models/usuario.model';
import { map } from 'rxjs/operators';
// [13/08/2026] Se retiró el import comentado de "aws-sdk/clients/s3": los métodos S3 (uploadFile, uploadFileLayout, delteFile) ya viven en el backend, el frontend sube archivos como base64 vía HttpClient.
import { Observable } from 'rxjs';

@Injectable()
export class FacturasService {

    token: string;

    constructor(public http: HttpClient,
                public router: Router) {

                }


    ////////////////////////////////////////
    xml(xmlData) {

      const XmlReader = require('xml-reader');
      const reader = XmlReader.create();
      const xhr = new XMLHttpRequest();
      // xhr.open('GET', '../../../assets/xml/1.xml');
      xhr.responseType = 'text';
      xhr.onload = function () {
        if (xhr.readyState === xhr.DONE) {
            if (xhr.status === 200) {
  
  
                const xml = xmlData; // xhr.response;
                reader.on('done', data => {console.log(data); return data; });
                reader.parse(xml);
                console.log(reader.parse(xml));
  
            }
        }
    };
  
      xhr.send(null);
  
    }
    ///////////////////////////////////////

    getInvoices() {

      const url = `${environment.URL_SERVICIOS}/invoices`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    getExecutedInvoices() {

      const url = `${environment.URL_SERVICIOS}/get_executed_invoices`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    checkInvoiceSat(params) {

      const url = `${environment.URL_SERVICIOS}/check_invoices_sat`;
      return this.http.post(url, params).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    getCompanyAccountStatus(id) {

      const url = `${environment.URL_SERVICIOS}/company_account_status?company_id=${id}`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    updateInvoices( id, params ) {
      const url = `${environment.URL_SERVICIOS}/invoices/${id}`;
      return this.http.patch( url, params ).pipe(
        map( (resp: any) => {
          return resp;
        }));
    }

    updateRateFee( params ) {
      const url = `${environment.URL_SERVICIOS}/invoices_rate`;
      return this.http.patch( url, params ).pipe(
        map( (resp: any) => {
          return resp;
        }));
    }

    rejectInvoices( params ) {
      const url = `${environment.URL_SERVICIOS}/reject_invoices`;
      return this.http.post( url, params )
    }

    deleteInvoice( id, params ) {
      const url = `${environment.URL_SERVICIOS}/invoices/${id}`;
      return this.http.delete( url, params ).pipe(
        map( (resp: any) => {
          return resp;
        }));
    }

    deleteInvoiceRepor( id ) {
      const url = `${environment.URL_SERVICIOS}/invoices/${id}`;
      return this.http.delete( url ).pipe(
        map( (resp: any) => {
          return resp;
        }));
    }

    guardaFactura(data) {

    const url = `${environment.URL_SERVICIOS}/invoices`;

    return this.http.post(url, data);

    }

    // LISTAS

    getInvoiceCurrency() {

      const url = `${environment.URL_SERVICIOS}/lists/domain/INVOICE_CURRENCY`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return this.crearArregloCurrency(resp);
        } )
      );
    }

    getInvoiceClavesUsoCfdi() {

      const url = `${environment.URL_SERVICIOS}/lists/domain/CLAVES_USO_CFDI`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return this.crearArregloClavesUsoCfdi(resp);
          // return resp;
        } )
      );
    }

    getInvoiceStatus() {

      const url = `${environment.URL_SERVICIOS}/lists/domain/INVOICE_STATUS`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return this.crearArregloCurrency(resp);
        } )
      );
    }
    crearArregloCurrency( contribuObj: any) {

      const rr: any[] = [];
      const resul: any[] = [];

      if ( contribuObj === null ) { return []; }
      Object.keys ( contribuObj ).forEach( key => {
        const rol: any = contribuObj[key];
        rr.push( rol );
      });
      // tslint:disable-next-line: forin
      for ( const prop in rr[0] ) {

        resul.push( rr[0][prop].attributes.value );

      }

      return resul;

    }

    crearArregloClavesUsoCfdi( contribuObj: any) {

      const rr: any[] = [];
      const resul: any[] = [];

      if ( contribuObj === null ) { return []; }
      Object.keys ( contribuObj ).forEach( key => {
        const rol: any = contribuObj[key];
        rr.push( rol );
      });
      // tslint:disable-next-line: forin
      for ( const prop in rr[0] ) {

        resul.push( rr[0][prop].attributes );

      }

      return resul;

    }

    getInvoicescopachisa() {

      const url = `${environment.URL_SERVICIOS}/reports/copachisa_invoices`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    postInvoicescopachisa(params: any, aut: string, urlcopa: string) { 
      let headers = new HttpHeaders({
        'Access-Control-Allow-Origin': 'http://localhost:4200/#/regfactcopachisa',
        'Content-Type': 'application/json',
        'Authorization': aut });
    let options = { headers: headers };
      return this.http.post(urlcopa,params, options).pipe(
        map( (resp: any) => {
          return (resp);
        } )
      );
    }

    postFacturaCopa(idf, idu, ip) {
      const url = `${environment.URL_SERVICIOS}/invoices/${idf}/invoice_details?invoice_detail[ip]=${ip}&invoice_detail[host]=localhostcopa&invoice_detail[status]=REGISTRO CADENA&invoice_detail[notes]=Registro factura copachisa&invoice_detail[user_id]=${idu}`;
      return this.http.post(url, null);
  
      }

     async getListxdomain(key: string) {

        const url = `${environment.URL_SERVICIOS}/get_general_param?key=${key}`;
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return (resp);
          } )
        );
      }

      async getIp() {

        const url = `http://api.ipify.org/?format=json`;
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return (resp);
          } )
        );
      }


      // document_shot
      getShots(){
        const url = `${environment.URL_SERVICIOS}/document_shots`;
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return (resp);
          } )
        );
      }

      getShot(id){
        const url = `${environment.URL_SERVICIOS}/document_shots/${id}`;
        return this.http.get(url).pipe(
          map( (resp: any) => {
            return (resp);
          } )
        );
      }
// Para el bucket de aws
/*async uploadFile(file: any) {
  const contentType = file.type;
  const bucket = new S3({
    accessKeyId: environment.AWS.accessKeyId,
    secretAccessKey: environment.AWS.secretAccessKey,
    region: environment.AWS.region,
  });
  const params = {
    Bucket: environment.AWS.bucketNomina,
    Key:
      environment.AWS.folder +
      "Facturas/" +
      file.name.substring(0, file.name.length - 4) +
      "/" +
      file.name,
    Body: file,
    ACL: "public-read",
    ContentType: contentType,
  };
  return bucket.upload(params).promise();
}*/

async uploadFileSB(file: any, name: string) {
  const url = `${environment.URL_SERVICIOS}/invoices/pdf_upload`;
  try {
    const base64File = await this.convertToBase64(file);
    const body = {
      nombre_documento: name,
      contentType: file.type,
      document: base64File
    };
    const response = await this.http.post(url, body).toPromise();
    return response;
  } catch (error) {
    throw error;
  }
}

uploadFileSBDD(file: any, name: string) {
  const url = `${environment.URL_SERVICIOS}/invoices/pdf_upload`;

  return new Observable((observer) => {

    // 1️⃣ Convertir a base64 sin async/await
    this.convertToBase64(file).then((base64File) => {
      const body = {
        nombre_documento: name,
        contentType: file.type,
        document: base64File
      };

      // 2️⃣ Aquí sí usamos HttpClient normalmente
      this.http.post(url, body).subscribe(
        (resp) => {
          observer.next(resp);
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );

    }).catch((err) => {
      observer.error(err);
    });

  });
}


async uploadFileLayoutSB(file: any, name: string) {
  const url = `${environment.URL_SERVICIOS}/invoices/pdf_upload`;
  try {
    const base64File = await this.convertToBase64(file);
    const body = {
      nombre_documento: name,
      contentType: file.type,
      document: base64File
    };
    console.log(body)
    const response = await this.http.post(url, body).toPromise();
    return response;
  } catch (error) {
    throw error;
  }
}

async fundersUploadw(file: any, name: string) {
  console.log(file);
const url = `https://run.mocky.io/v3/b2fb927e-43af-4b6c-91a7-4970451a4883`;
return this.http.get(url).pipe(
  map( (resp: any) => {
    return (resp);
  } )
);
}

async fundersUpload(file: File, name: string): Promise<{ message: string; url: string }> {
  const url = `${environment.URL_SERVICIOS}/invoices/pdf_upload_2`;
  //const url = `https://run.mocky.io/v3/b2fb927e-43af-4b6c-91a7-4970451a4883`;
  // para el from data
  const formData = new FormData();
  formData.append('nombre_documento', name); 
  formData.append('contentType', file.type); 
  formData.append('document', file);
  try {
    const response = await this.http.post<{ message: string; url: string }>(url, formData).toPromise();
    return response;
  } catch (error) {
    throw error;
  }
}

async fundersUploadtxt(file: any, name: string): Promise<{ message: string; url: string }> {
  const url = `${environment.URL_SERVICIOS}/invoices/pdf_upload`;
  try {
    const base64File = await this.convertToBase64(file);
    const body = {
      nombre_documento: name,
      contentType: file.type,
      document: base64File
    };
    console.log(body)
    const response = await this.http.post<{ message: string; url: string }>(url, body).toPromise();
    return response;
  } catch (error) {
    throw error;
  }
}

private convertToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
          const base64String = (reader.result as string).replace(/^data:[a-zA-Z\/]+;base64,/, '');
          resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
  });
}

/*async delteFile(key: string) {
  const params = {
    Bucket: "nominabucket",
    Key: key,
  };
  const s3 = new S3({
    accessKeyId: environment.AWS.accessKeyId,
    secretAccessKey: environment.AWS.secretAccessKey,
    region: environment.AWS.region,
  });
  s3.deleteObject(params, function (err, data) {
    if (err) console.log(err);
    else console.log("Successfully deleted myBucket/myKey");
  });
}*/

async guardaFacturaDD(data) {

  //const url = `${environment.URL_SERVICIOS}/invoices?invoice[admin]=SI`;
  const url = `${environment.URL_SERVICIOS}/invoices`;
  return this.http.post(url, data).pipe(
    map((resp: any) => {
      // console.log(resp);
      return resp; //this.crearArreglosimul(resp);
    })
  );
}

guardaFacturaDDDD(data) {
  const url = `${environment.URL_SERVICIOS}/invoices`;
  return this.http.post(url, data).pipe(
    map((resp: any) => {
      return resp;
    })
  );
}

/*async uploadFileLayout(file: any) {
  const contentType = file.type;
  const bucket = new S3({
    accessKeyId: environment.AWS.accessKeyId,
    secretAccessKey: environment.AWS.secretAccessKey,
    region: environment.AWS.region,
  });
  const params = {
    Bucket: environment.AWS.bucketNomina,
    Key:
      environment.AWS.folder +
      "FacturasLayout/" +
      file.name.substring(0, file.name.length - 4) +
      "/" +
      file.name,
    Body: file,
    ACL: "public-read",
    ContentType: contentType,
  };
  return bucket.upload(params).promise();
}*/

async guardaFacturaLayout(data) {

  //const url = `${environment.URL_SERVICIOS}/invoices?invoice[admin]=SI`;
  const url = `${environment.URL_SERVICIOS}/invoices`;
  return this.http.post(url, data).pipe(
    map((resp: any) => {
       //console.log(resp);
      return resp; //this.crearArreglosimul(resp);
    })
  );
}

getRfcUser(id){
  const url = `${environment.URL_SERVICIOS}/reports/user_id/${id}/get_rfc_from_user`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getFacturasUser(id){
  const url = `${environment.URL_SERVICIOS}/reports/user_id/${id}/user_invoices`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getEstatusFacturas() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/INVOICE_STATUS`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloRate(resp);
    } )
  );

}

getReviewInvoices(id) {

  const url = `${environment.URL_SERVICIOS}/review_invoices?company_id=${id}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );

}

getInvoicesFinantah(id) {

  const url = `${environment.URL_SERVICIOS}/review_invoice_rate?user_id=${id}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );

}

getCompanyForReview() {

  const url = `${environment.URL_SERVICIOS}/company_for_review`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );

}

crearArregloRate( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes.value );

  }

  return resul;

}

borraFacturaBucket(urlBucket: string) {
  const url = `${environment.URL_SERVICIOS}/file_delete`;
    return new Observable((observer) => {
      const body = {
        url:urlBucket
      }
      // 2️⃣ Aquí sí usamos HttpClient normalmente
      this.http.post(url, body).subscribe(
        (resp) => {
          observer.next(resp);
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );

  });
}
}
